"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageNotFound = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _material = require("@mui/material");
var _PrecisionManufacturing = _interopRequireDefault(require("@mui/icons-material/PrecisionManufacturing"));
var _Home = _interopRequireDefault(require("@mui/icons-material/Home"));
var _react2 = require("@emotion/react");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const rotate = (0, _react2.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n"])));

/**
 * A component that displays a "Page Not Found" message.
 * @component
 * @example
 * return (
 *   <DmsPageNotFound />
 * )
 */
const DmsPageNotFound = () => {
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    textAlign: "center",
    mt: 4
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: _PrecisionManufacturing.default,
    sx: {
      fontSize: 80,
      mb: 2,
      color: 'error.main',
      animation: "".concat(rotate, " 2s linear infinite")
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h1",
    gutterBottom: true
  }, _reactIntlUniversal.default.get("404Error").d("404 Error")), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h4",
    gutterBottom: true
  }, _reactIntlUniversal.default.get("PageNotFound").d("Page Not Found")), /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "primary",
    startIcon: /*#__PURE__*/_react.default.createElement(_Home.default, null),
    component: _reactRouterDom.Link,
    to: "/"
  }, _reactIntlUniversal.default.get("GoHome").d("Go Home")));
};
exports.DmsPageNotFound = DmsPageNotFound;